import { useTranslation } from 'react-i18next';
import { Dropdown } from 'react-bootstrap';
import { RiTranslate2 } from '@remixicon/react';
import useLanguageStore from '../../stores/languageStore';

function LanguageSwitcher() {
    const { i18n } = useTranslation();
    const { language, setLanguage } = useLanguageStore();

    const languages = [
        { code: 'fr', name: 'Français' },
        { code: 'en', name: 'English' }
    ];

    const handleChangeLanguage = async (lng) => {
        await i18n.changeLanguage(lng);
        setLanguage(lng);
    };

    return (
        <Dropdown>
            <Dropdown.Toggle
                variant="link"
                id="language-dropdown"
                className="d-flex align-items-center gap-2"
                style={{ color: 'white', textDecoration: 'none' }}
            >
                <RiTranslate2 size={20} />
                {language.toUpperCase()}
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {languages.map((lang) => (
                    <Dropdown.Item
                        key={lang.code}
                        onClick={() => handleChangeLanguage(lang.code)}
                        active={language === lang.code}
                    >
                        {lang.name}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
}

export default LanguageSwitcher;